import { Component, Input } from '@angular/core';
import { Road } from 'src/app/modules/route-planner/models/route-signposts-model';

@Component({
    selector: 'aa-hospital-signpost',
    templateUrl: './aa-hospital-signpost.component.html',
    styleUrls: ['./aa-hospital-signpost.component.scss'],
    standalone: false
})
export class AaHospitalSignpostComponent {

  @Input() road: Array<Road>;

  constructor() { }

  get roads() {
    return this.road;
  }
  trackByFn(index: number): number {
    return index;
  }
}
